"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiCalculator16 = {
    paths: [
        {
            path: 'M0,1.00684547 C0,0.450780073 0.449948758,0 1.00684547,0 L12.9931545,0 C13.5492199,0 14,0.449948758 14,1.00684547 L14,12.9931545 C14,13.5492199 13.5500512,14 12.9931545,14 L1.00684547,14 C0.450780073,14 0,13.5500512 0,12.9931545 L0,1.00684547 Z M2,2 L2,12 L12,12 L12,2 L2,2 Z M6,8 L8,8 L8,10 L6,10 L6,12 L4,12 L4,10 L2,10 L2,8 L4,8 L4,6 L6,6 L6,8 Z M8,6 L10,6 L10,12 L8,12 L8,6 Z M2,4 L12,4 L12,6 L2,6 L2,4 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Calculator',
    width: 14,
    height: 14,
};
var muiCalculator24 = {
    paths: [
        {
            path: 'M20,22.9993054 C20,23.5519738 19.5446944,24 19.0081969,24 L0.99180311,24 C0.444045377,24 0,23.5525308 0,22.9993054 L0,1.00069463 C0,0.448026248 0.455305576,0 0.99180311,0 L19.0081969,0 C19.5559546,0 20,0.44746922 20,1.00069463 L20,22.9993054 Z M2,22 L4,22 L4,20 L2,20 L2,22 Z M8,20 L6,20 L6,22 L8,22 L8,20 Z M12,20 L10,20 L10,22 L12,22 L12,20 Z M18,16 L14,16 L14,22 L18,22 L18,16 Z M2,18 L4,18 L4,16 L2,16 L2,18 Z M12,16 L10,16 L10,18 L12,18 L12,16 Z M18,14 L18,12 L14,12 L14,14 L18,14 Z M2,14 L4,14 L4,12 L2,12 L2,14 Z M18,10 L18,8 L14,8 L14,10 L18,10 Z M2,10 L4,10 L4,8 L2,8 L2,10 Z M18,2 L2,2 L2,6 L18,6 L18,2 Z M6,18 L8,18 L8,16 L6,16 L6,18 Z M6,14 L8,14 L8,12 L6,12 L6,14 L6,14 Z M12,14 L12,12 L10,12 L10,14 L12,14 L12,14 Z M6,10 L8,10 L8,8 L6,8 L6,10 Z M12,10 L12,8 L10,8 L10,10 L12,10 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Calculator',
    width: 20,
    height: 24,
};
var muiCalculator = {
    base: muiCalculator16,
    smIcon: muiCalculator16,
    lgIcon: muiCalculator24,
};
exports.muiCalculator = muiCalculator;
//# sourceMappingURL=calculator.js.map